function standardError(error: unknown): string {
  if (typeof error === 'object' && error !== null) {
    // Type Object or Array.
    if (Array.isArray(error)) {
      return error
        .map((ind) => {
          if (typeof ind === 'string') {
            return ind;
          }
          return standardError(ind);
        })
        .join(`\n`);
    }
    return Object.entries(error)
      .map(([key, value]) => {
        if (key === undefined) return '';
        if (['string', 'number'].includes(typeof value)) {
          return `${key}: ${value}`;
        }
        if (Array.isArray(value)) {
          return `${key}:${standardError(value)}`;
        }
        return `${key}:
          ${standardError(value)}`;
      })
      .join(`\n`);
  }
  return JSON.stringify(error)
    ?.replace(/\\n/g, '\n')
    ?.replace(/"/g, '"')
    ?.replace(/'/g, "'")
    ?.trim()
    ?.replace(/^"/, '')
    ?.replace(/"$/, '');
}
export { standardError };
